import React from "react";
import { Table } from "reactstrap";
import { addInviteesButton } from "../../../Utils/addinviteesButton";
import { addClassName } from "../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../Utils/calculate-progress.js";
import { formatDate } from "../../../Utils/format-date.js";
import completed from "../../../../images/new-images/completed.png";
import "./Received.css";
import MyinvitationsEmpty from "../Invitations-Empty";
import moment from "moment";

const Received = (props) => {
  const currentDate = moment().format("YYYY-MM-DD");
  return (
    <div
      style={
        props.receivedInvitations.length == 1 ||
        props.receivedInvitations.length == 2 ||
        props.receivedInvitations.length == 3
          ? { height: "auto" }
          : { height: "410px", overflowY: "auto" }
      }
      className="received-tab"
    >
      {props.receivedInvitations.length == 0 ? (
        <MyinvitationsEmpty emptyText="You do not have any invitations yet." />
      ) : (
        <Table>
          <thead>
            <tr>
              <th className="tableHeaders">From</th>
              <th className="tableHeaders">Relationship</th>
              <th className="tableHeaders">Date of Expiry</th>
              <th className="tableHeaders">Status</th>
              <th className="tableHeaders">Action</th>
            </tr>
          </thead>
          <tbody>
            <React.Fragment>
              {props.receivedInvitations.map((details, index) => {
                return (
                  <tr key={index}>
                    <td>{details.user_assessment__participant__full_name}</td>
                    <td>{details.assessor_group__assessor_name}</td>
                    <td>{formatDate(details.user_assessment__expiry_date)}</td>
                    <td>
                      {currentDate > details.user_assessment__expiry_date ? (
                        <div style={{ color: "#f00" }}>Expired</div>
                      ) : details.assessment_status__status_name ===
                        "In progress" ? (
                        <div
                          style={{ display: "flex" ,gap:"10px" }}
                          className={
                            "assessment-status-text " +
                            addClassName(details.assessment_status__status_name)
                          }
                        >
                          {details.assessment_status__status_name}
                          {calcPercentage(
                            details.user_assessment__assessment_number_count,
                            details.respondent_completed_count
                          )}
                        </div>
                      ) : details.assessment_status__status_name ===
                        "Completed" ? (
                        <div
                          className={
                            "assessment-status-text " +
                            addClassName(details.assessment_status__status_name)
                          }
                        >
                          {details.assessment_status__status_name}
                          <img src={completed} alt="Completed Image" />
                        </div>
                      ) : (
                        <div
                          className={
                            "assessment-status-text " +
                            addClassName(details.assessment_status__status_name)
                          }
                        >
                          {details.assessment_status__status_name}
                        </div>
                      )}
                    </td>
                    <td>{addInviteesButton(details)}</td>
                  </tr>
                );
              })}
            </React.Fragment>
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default Received;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Received/Received.jsx